import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import ListDataPage from '../../../components/pages/ListDataPage';
import dayjs from 'dayjs';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { convertCrmOpportunityToCustomer } from '../../../services/crmOpportunityService';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const CRMOpportunity = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (
    opportunity_id: string,
    institutes_id: string = ''
  ): ActionItem[] => [
    {
      eventKey: '1',
      label: 'View',
      type: 'function',
      callback: () =>
        navigate(`/crm/opportunities/opportunity-details/${opportunity_id}`)
    },
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () =>
        navigate(`/crm/opportunities/edit-opportunity/${opportunity_id}`)
    },
    {
      eventKey: '3',
      label: 'Remove',
      type: 'function',
      callback: () => alert(`Removing Lead ${opportunity_id}`),
      className: 'text-danger'
    },
    {
      eventKey: '4',
      label: 'Create Quote',
      type: 'function',
      callback: () =>
        navigate(`/crm/opportunities/${institutes_id}/create-quote`)
    },
    {
      eventKey: '4',
      label: 'Convert to Customer',
      type: 'function',
      callback: () => convertCrmOpportunityToCustomer(`${opportunity_id}`)
    }
  ];

  const columns = [
    { accessorKey: 'opportunity_id', header: 'Opportunity ID' },
    { accessorKey: 'priority', header: 'Priority' },
    { accessorKey: 'status', header: 'Status' },
    { accessorKey: 'expected_close_date', header: 'Expected close date' },
    {
      accessorKey: 'user',
      header: 'Assigned To',
      cell: ({ row }: { row: any }) => {
        const user = row.original.user;
        return user ? `${user.username} ${user.email} ${user.role}` : 'N/A'; // Handle cases where user data might be missing
      }
    },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(
                row.original.opportunity_id,
                row.original.institute.crm_institute_id
              )}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useCRMOpportunities}
      entityName="CRM Opportunity"
      columns={columns}
    />
  );
};

export default CRMOpportunity;
